/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-11 14:21:40
 *
 *******************************************************/
// @flow
import React, { Component } from 'react';
import { FormLayout, TextStyle, Link, Icon } from '@shopify/polaris';
import { ExternalMinor } from '@shopify/polaris-icons';

import { Field } from 'redux-form';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { DropdownIndicator, styles } from './react-select-style';
import { RenderSelect2 } from 'src/components/views/common/forms/render-select-2-v2';
import { PRODUCT_COUNT_TEXT_DESCRIPTION_OPTIONS } from 'src/constants/theme-settings.js';
import { URL } from 'src/constants/links';

type Props = {
  formValues: any,
  updateField: (field: string, value: any) => void
};

type ComposedProps = Props & WithI18nProps;

class ToolBarProductCountForm extends Component<ComposedProps> {
  state = {};

  render() {
    const { i18n, prefix } = this.props;

    const textDescriptionOptions = PRODUCT_COUNT_TEXT_DESCRIPTION_OPTIONS.map(option => {
      const { label, value } = option;
      return {
        label: i18n.translate(label, {
          t1: '{{count}}',
          t2: '{{from}}',
          t3: '{{to}}',
          t4: '{{total}}'
        }),
        value
      };
    });

    return (
      <FormLayout>
        <div>
          <span className="form-link">
            <TextStyle variation="subdued">
              {i18n.translate('AdminHTML.ThemeSetting.Form.toolBar_ProductCount_UserGuide')}
            </TextStyle>{' '}
            <Link url={URL['ToolBarProductCountThemeSetting']} external>
              {i18n.translate('AdminHTML.ThemeSetting.Common.clickHere')}
              <Icon source={ExternalMinor} color="base" />
            </Link>
            <span style={{ color: '#2C6ECB' }}>.</span>
          </span>
        </div>

        <div className="form-section">
          <div className="form-section__item">
            <Field
              name={`${prefix}.textDescription`}
              component={RenderSelect2}
              options={textDescriptionOptions}
              label={i18n.translate(
                'AdminHTML.ThemeSetting.Form.toolBar_ProductCount_TextDescription_Label'
              )}
              components={{ DropdownIndicator }}
              styles={styles}
              // props={{
              //   textHelper: i18n.translate(
              //     'AdminHTML.ThemeSetting.Form.toolBar_ProductCount_TextDescription_HelpText',
              //     { t1: '{{count}}' }
              //   )
              // }}
            />
          </div>
        </div>
      </FormLayout>
    );
  }
}

export default withI18n()(ToolBarProductCountForm);
